import React, { useEffect, useState } from 'react';

import './index.css';


 function App(){
   const [users, setUsers] = useState([]);
  const getUsers = async () => {
    const response = await fetch('https://randomuser.me/api/');
    
    setUsers(await response.json());
    
  }
  useEffect(()=>{
    getUsers();
  },[]);
  if(users.length===0){
    return <div></div>
  }

  return (
   <>
   
   <div className="container">
    <div className="map">
      <div id="map">

      </div>
     <div className="heading">
       <img className="img" style={{borderRadius:'50%',width:'20%'}}  src={users.results[0].picture.medium} alt="profile" ></img>
       <div className="headingname">
           <h3>Your Name</h3>
           <div>Update your photo and personal details</div>
       </div>
     </div>
    </div>
    <div className="details">
      
    <div className="name"    contentEditable="true">{`Username : ${users.results[0].name.title} ${users.results[0].name.first} ${users.results[0].name.last}`}</div>
    <div contentEditable="true" className="gender">Gender: {users.results[0].gender}</div>
    <div className="location">
     <div contentEditable="true">Street number : {users.results[0].location.street.number}</div>
     <div contentEditable="true">Street name : {users.results[0].location.street.name}</div>
     <div contentEditable="true">City : {users.results[0].location.city}</div>
     <div contentEditable="true">State : {users.results[0].location.state}</div>
     <div contentEditable="true">Country : {users.results[0].location.country}</div>
     <div contentEditable="true">latitude : {users.results[0].location.coordinates.latitude}</div>
     <div contentEditable="true">longitude : {users.results[0].location.coordinates.longitude}</div>
    </div>
    <div className="email" contentEditable="true">Email : {users.results[0].email}</div>
    <div className="dob" contentEditable="true">DOB : {users.results[0].dob.date}</div>
    <div className="age" contentEditable="true">Age : {users.results[0].dob.age}</div>
    <div className="phone" contentEditable="true">Phone no : {users.results[0].phone}</div>
    </div>
   </div>
   </> 
  );
}

export default App;
